export default __webpack_public_path__ + "static/pump_w.6fa77dc6bc3ee1b361ff4aa546017d1d.svg";